import { render } from "./buttonConfig.vue?vue&type=template&id=70ddd575"
import script from "./buttonConfig.vue?vue&type=script&lang=js"
export * from "./buttonConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__